<template>
  <div class="pt-4 width-100 px-4">
    <b class="font-weight-black">채권자 정보</b>
    <table class="mt-2 font-weight-bold text-center width-100">
      <tr>
        <td>회사명</td>
        <td>
          <span class="seal-box">
            <span>(주)펀다에이아이</span>
            <img src="@/assets/images/documents/funda_onto_seal.png" />
          </span>
        </td>
      </tr>
      <tr>
        <td>등록번호</td>
        <td>온라인투자연계금융업<br />2022-금융위원회-18</td>
      </tr>
      <tr>
        <td>전화번호</td>
        <td>
          02-6925-1788
        </td>
      </tr>
      <tr>
        <td>사업자등록번호</td>
        <td>724-87-00107</td>
      </tr>
      <tr>
        <td>주소</td>
        <td>서울시 금천구 가산디지털1로 70, 5층 514호(가산동, 호서대벤처타워)</td>
      </tr>
    </table>
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
table td .seal-box {
  position: relative;

  span {
    z-index: 1;
    position: relative;
  }

  img {
    position: absolute;
    width: 60px;
    right: -5px;
    transform: translate(50%, -25%);
  }
}
</style>
